<app-mmp-ai-summary
  [progressTagMsg]="progressTagMsg"
  progressTagClass="completed"
  [progressTimeText]="progressTimeText"
  [progressTime]="progressTime"
  [aiSummaryContent]="aiSummaryContent"
  [courseCount]="aiSummaryCourseCount"
  [flaggedCount]="aiSummaryFlaggedCount"
  [confidenceScore]="aiSummaryConfidenceScore"
  [currentTab]="currentStage"
></app-mmp-ai-summary>
<div class="extraction-container">
  <div class="extraction-header header-section horizontal-line">
    <div class="extraction-title title-section">Extraction Result</div>
    <div class="extraction-flag-toggle toggle-section horizontal-line">
      <app-mmp-flag-component></app-mmp-flag-component>
      Flagged Items Only
      <label class="switch" for="highlight_toggle">
        <input
          type="checkbox"
          class="higlight-toggle"
          [(ngModel)]="isHighlightToggleChecked"
          id="highlight_toggle"
          aria-label="Toggle to show flagged items only"
          [disabled]="isEditLocked()"
        />
        <span class="slider round" aria-hidden="true"></span>
      </label>
    </div>
  </div>
  <div class="extraction-body">
    @if (isHighlightToggleChecked && areAllTabsLowConfidenceFree()) {
      <div class="no-flagged-item">No flagged items found.</div>
    }
    @if (!isHighlightToggleChecked || hasLowConfidenceInStudent()) {
      <div class="student-information" [formGroup]="studentForm">
        <div class="action-section horizontal-line">
          <span class="info-header">Student Information</span>
          @if (!isStudentEdit) {
            <button
              class="edit-icon"
              (click)="studentInfoEdit()"
              [class.disabled]="isEditActionLocked()"
              [style.pointer-events]="isEditActionLocked() ? 'none' : 'auto'"
              (keydown.enter)="studentInfoEdit()"
              (keydown.space)="$event.preventDefault(); studentInfoEdit()"
              [attr.tabindex]="isEditActionLocked() ? -1 : 0"
              aria-label="Edit student information"
              title="Edit"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_student_edit)">
                  <path
                    d="M3 15.0002H6L13.875 7.12523C14.072 6.92824 14.2282 6.69439 14.3348 6.43702C14.4415 6.17965 14.4963 5.9038 14.4963 5.62523C14.4963 5.34665 14.4415 5.0708 14.3348 4.81343C14.2282 4.55606 14.072 4.32221 13.875 4.12523C13.678 3.92824 13.4442 3.77199 13.1868 3.66538C12.9294 3.55878 12.6536 3.50391 12.375 3.50391C12.0964 3.50391 11.8206 3.55878 11.5632 3.66538C11.3058 3.77199 11.072 3.92824 10.875 4.12523L3 12.0002V15.0002Z"
                    stroke="#5F626B"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.125 4.875L13.125 7.875"
                    stroke="#5F626B"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_student_edit">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          }
          @if (isStudentEdit) {
            <span class="save-section horizontal-line">
              <button
                class="cancel-icon"
                (click)="cancelStudentEdit()"
                (keydown.enter)="cancelStudentEdit()"
                (keydown.space)="$event.preventDefault(); cancelStudentEdit()"
                [attr.tabindex]="isEditActionLocked() ? -1 : 0"
                aria-label="Cancel student edit"
              >
                Cancel
              </button>
              <button
                class="save-icon"
                [class.disabled]="studentForm?.invalid"
                (click)="saveStudentEdit()"
                (keydown.enter)="saveStudentEdit()"
                (keydown.space)="$event.preventDefault(); saveStudentEdit()"
                [attr.tabindex]="
                  studentForm?.invalid || isEditActionLocked() ? -1 : 0
                "
              >
                Save
              </button>
            </span>
          }
        </div>
        <div class="form-section horizontal-line">
          @if (confidenceResult) {
            <div
              class="field-container"
              [class.edit-mode]="isStudentEdit"
              [ngClass]="{
                'low-confidence': isLowConfidence(
                  confidenceResult?.student_information?.name
                ),
                'edited-field':
                  savedChanges?.student?.['name'] != undefined &&
                  !isStudentEdit &&
                  isLowConfidence(savedConfidenceChanges?.student?.['name']),
              }"
            >
              <div class="input-wrapper">
                <div class="label-row">
                  <label class="floating-label" for="student_name">Name</label>
                  @if (!savedChanges?.student?.["name"] && !isStudentEdit) {
                    <app-salesforce-tag
                      [svgTitle]="salesFlagTitle"
                    ></app-salesforce-tag>
                  }
                  @if (
                    isLowConfidence(
                      confidenceResult?.student_information?.name
                    ) && !isStudentEdit
                  ) {
                    <app-low-confidence-tag
                      [confidenceScore]="
                        confidenceResult?.student_information?.name
                      "
                      (markDataCorrect)="markStudentInfoAsCorrect('name')"
                    ></app-low-confidence-tag>
                  }
                  @if (
                    savedChanges?.student?.["name"] != undefined &&
                    !isStudentEdit
                  ) {
                    <span class="edited-icon"
                      ><app-edited-field-tag
                        [previousValue]="savedChanges?.student?.['name']"
                      ></app-edited-field-tag>
                    </span>
                  }
                </div>
                <input
                  id="student_name"
                  type="text"
                  formControlName="name"
                  [readonly]="!isStudentEdit"
                  [class.readonly]="!isStudentEdit"
                  (input)="onNameInput($event)"
                  [ngClass]="{
                    'error-border':
                      studentForm.get('name')?.invalid &&
                      studentForm.get('name')?.touched,
                  }"
                />
              </div>
            </div>
          }
          @if (shouldRenderDobField()) {
            <div
              class="field-container long-content"
              [class.edit-mode]="isStudentEdit"
              [ngClass]="{
                'low-confidence': isLowConfidence(
                  confidenceResult?.student_information?.date_of_birth
                ),
                'edited-field':
                  savedChanges?.student?.['date_of_birth'] &&
                  !isStudentEdit &&
                  isLowConfidence(
                    savedConfidenceChanges?.student?.['date_of_birth']
                  ),
              }"
            >
              <div class="input-wrapper">
                <div class="label-row">
                  <label class="floating-label" for="date_of_birth"
                    >Date of Birth</label
                  >
                  @if (
                    isLowConfidence(
                      confidenceResult?.student_information?.date_of_birth
                    ) && !isStudentEdit
                  ) {
                    <app-low-confidence-tag
                      [confidenceScore]="
                        confidenceResult?.student_information?.date_of_birth
                      "
                      (markDataCorrect)="
                        markStudentInfoAsCorrect('date_of_birth')
                      "
                    ></app-low-confidence-tag>
                  }
                  @if (
                    savedChanges?.student?.["date_of_birth"] != undefined &&
                    !isStudentEdit
                  ) {
                    <span class="edited-icon"
                      ><app-edited-field-tag
                        [previousValue]="savedChanges?.student?.date_of_birth"
                      ></app-edited-field-tag>
                    </span>
                  }
                </div>
                <div class="datepicker-wrapper">
                  <input
                    id="date_of_birth"
                    type="text"
                    formControlName="date_of_birth"
                    [readonly]="!isStudentEdit"
                    [class.readonly]="!isStudentEdit"
                    placeholder="-"
                    [ngClass]="{
                      'error-border':
                        isStudentEdit &&
                        studentForm.get('date_of_birth')?.invalid &&
                        studentForm.get('date_of_birth')?.touched,
                    }"
                  />
                </div>
              </div>
            </div>
          }
          <div class="field-container">
            <div class="input-wrapper">
              <div class="label-row"></div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="transcript-results">
      <mat-tab-group
        class="transcript-group"
        [(selectedIndex)]="selectedTranscriptIndex"
        (click)="onTranscriptTabClick($event)"
        (keydown)="onTranscriptTabClick($event)"
        (selectedIndexChange)="onTranscriptTabChange($event)"
      >
        @for (
          transcript of extractionResult.transcripts;
          track transcript;
          let i = $index
        ) {
          @if (!isHighlightToggleChecked || hasLowInTab[i]) {
            <mat-tab
              [label]="transcript.name"
              [disabled]="isTabSwitchBlocked() && selectedTranscriptIndex !== i"
            >
              <ng-template mat-tab-label>
                <span class="transcript-tab-label-wrap">
                  @if (hasLowInTab[i]) {
                    <app-mmp-flag-component></app-mmp-flag-component>
                  }
                  <span
                    class="transcript-tab-label-text"
                    [title]="transcript.name"
                  >
                    {{ transcript.name }}
                  </span>
                </span>
              </ng-template>
              @if (!isHighlightToggleChecked || hasLowConfidenceInCollege(i)) {
                <div
                  class="college-information"
                  [formGroup]="getCollegeForm(i)"
                >
                  @if (transcriptAlert) {
                    <div class="transcript-alert">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_alert)">
                          <path
                            d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9Z"
                            stroke="#FA0000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 6.75V9.75"
                            stroke="#FA0000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12V12.0075"
                            stroke="#FA0000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_alert">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Please save or cancel your changes before moving to the
                      next tab.
                    </div>
                  }
                  <div class="action-section horizontal-line">
                    <span class="info-header">College Information</span>
                    @if (collegeEditIndex !== i) {
                      <button
                        class="edit-icon"
                        (click)="editCollege(i)"
                        [class.disabled]="isEditActionLocked()"
                        [style.pointer-events]="
                          isEditActionLocked() ? 'none' : 'auto'
                        "
                        (keydown.enter)="editCollege(i)"
                        (keydown.space)="
                          $event.preventDefault(); editCollege(i)
                        "
                        [attr.tabindex]="isEditActionLocked() ? -1 : 0"
                        aria-label="Edit college"
                        title="Edit"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_college_edit)">
                            <path
                              d="M3 15.0002H6L13.875 7.12523C14.072 6.92824 14.2282 6.69439 14.3348 6.43702C14.4415 6.17965 14.4963 5.9038 14.4963 5.62523C14.4963 5.34665 14.4415 5.0708 14.3348 4.81343C14.2282 4.55606 14.072 4.32221 13.875 4.12523C13.678 3.92824 13.4442 3.77199 13.1868 3.66538C12.9294 3.55878 12.6536 3.50391 12.375 3.50391C12.0964 3.50391 11.8206 3.55878 11.5632 3.66538C11.3058 3.77199 11.072 3.92824 10.875 4.12523L3 12.0002V15.0002Z"
                              stroke="#5F626B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.125 4.875L13.125 7.875"
                              stroke="#5F626B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_college_edit">
                              <rect width="18" height="18" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    }
                    @if (collegeEditIndex === i) {
                      <span class="save-section">
                        <button
                          class="cancel-icon"
                          (click)="cancelCollegeEdit(i)"
                          (keydown.enter)="cancelCollegeEdit(i)"
                          (keydown.space)="
                            $event.preventDefault(); cancelCollegeEdit(i)
                          "
                          [attr.tabindex]="isEditActionLocked() ? -1 : 0"
                          aria-label="Cancel college edit"
                        >
                          Cancel
                        </button>
                        <button
                          class="save-icon"
                          (click)="saveCollegeEdit(i)"
                          (keydown.enter)="saveCollegeEdit(i)"
                          [class.disabled]="getCollegeForm(i)?.invalid"
                          (keydown.space)="
                            $event.preventDefault(); saveCollegeEdit(i)
                          "
                          [attr.tabindex]="
                            getCollegeForm(i)?.invalid || isEditActionLocked()
                              ? -1
                              : 0
                          "
                          aria-label="Save college edit"
                        >
                          Save
                        </button>
                      </span>
                    }
                  </div>
                  <div class="form-section horizontal-line">
                    <div
                      class="field-container"
                      [class.edit-mode]="collegeEditIndex === i"
                      [ngClass]="{
                        'low-confidence': isLowConfidence(
                          confidenceResult?.transcripts?.[i]?.college
                            ?.institution_name
                        ),
                        'edited-field':
                          savedChanges?.college?.[i]?.institution_name !=
                            undefined &&
                          collegeEditIndex !== i &&
                          isLowConfidence(
                            savedConfidenceChanges?.college?.[i]
                              ?.institution_name
                          ),
                      }"
                    >
                      <div class="input-wrapper">
                        <div class="label-row">
                          <label
                            class="floating-label"
                            for="college_name_{{ i }}"
                            >College Name</label
                          >
                          @if (
                            isLowConfidence(
                              confidenceResult?.transcripts?.[i]?.college
                                ?.institution_name
                            ) && collegeEditIndex !== i
                          ) {
                            <app-low-confidence-tag
                              [confidenceScore]="
                                confidenceResult?.transcripts?.[i]?.college
                                  ?.institution_name
                              "
                              (markDataCorrect)="
                                markCollegeFieldAsCorrect(i, 'institution_name')
                              "
                            ></app-low-confidence-tag>
                          }
                          @if (
                            savedChanges?.college?.[i]?.institution_name !=
                              undefined && collegeEditIndex !== i
                          ) {
                            <span class="edited-icon"
                              ><app-edited-field-tag
                                [previousValue]="
                                  savedChanges?.college?.[i]?.institution_name
                                "
                              ></app-edited-field-tag>
                            </span>
                          }
                        </div>
                        <input
                          id="college_name_{{ i }}"
                          type="text"
                          formControlName="institution_name"
                          [readonly]="collegeEditIndex !== i"
                          [class.readonly]="collegeEditIndex !== i"
                          [title]="transcript.college.institution_name"
                          (input)="
                            onInstitutionNameInput(
                              $event,
                              getCollegeForm(i)?.get('institution_name')
                            )
                          "
                          [ngClass]="{
                            'error-border':
                              getCollegeForm(i)?.get('institution_name')
                                ?.invalid &&
                              getCollegeForm(i)?.get('institution_name')
                                ?.touched,
                          }"
                        />
                      </div>
                    </div>
                    <div
                      class="field-container"
                      [class.edit-mode]="collegeEditIndex === i"
                      [ngClass]="{
                        'low-confidence': isLowConfidence(
                          confidenceResult?.transcripts?.[i]?.college
                            ?.credit_system
                        ),
                        'edited-field':
                          savedChanges?.college?.[i]?.credit_system !=
                            undefined &&
                          collegeEditIndex !== i &&
                          isLowConfidence(
                            savedConfidenceChanges?.college?.[i]?.[
                              'credit_system'
                            ]
                          ),
                      }"
                    >
                      <div class="input-wrapper">
                        <div class="label-row">
                          <label
                            class="floating-label"
                            for="credit_system_{{ i }}"
                            >Credit Type</label
                          >
                          @if (
                            isLowConfidence(
                              confidenceResult?.transcripts?.[i]?.college
                                ?.credit_system
                            ) && collegeEditIndex !== i
                          ) {
                            <app-low-confidence-tag
                              [confidenceScore]="
                                confidenceResult?.transcripts?.[i]?.college
                                  ?.credit_system
                              "
                              (markDataCorrect)="
                                markCollegeFieldAsCorrect(i, 'credit_system')
                              "
                            ></app-low-confidence-tag>
                          }
                          @if (
                            savedChanges?.college?.[i]?.credit_system !=
                              undefined && collegeEditIndex !== i
                          ) {
                            <span class="edited-icon"
                              ><app-edited-field-tag
                                [previousValue]="
                                  savedChanges?.college?.[i]?.credit_system
                                "
                              ></app-edited-field-tag>
                            </span>
                          }
                        </div>
                        <select
                          id="credit_system_{{ i }}"
                          formControlName="credit_system"
                          [class.readonly]="collegeEditIndex !== i"
                          [title]="transcript.college.credit_system"
                          [ngClass]="{
                            'error-border':
                              getCollegeForm(i)?.get('credit_system')
                                ?.invalid &&
                              getCollegeForm(i)?.get('credit_system')?.touched,
                          }"
                        >
                          <option [ngValue]="null" disabled selected>-</option>
                          <option [ngValue]="creditSystemOptions.quarter">
                            Quarter
                          </option>
                          <option [ngValue]="creditSystemOptions.semester">
                            Semester
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="field-container long-content"
                      [class.edit-mode]="collegeEditIndex === i"
                      [ngClass]="{
                        'low-confidence': isLowConfidence(
                          confidenceResult?.transcripts?.[i]?.college
                            ?.transcript_issue_date
                        ),
                        'edited-field':
                          savedChanges?.college?.[i]?.transcript_issue_date !=
                            undefined &&
                          collegeEditIndex !== i &&
                          isLowConfidence(
                            savedConfidenceChanges?.college?.[i]?.[
                              'transcript_issue_date'
                            ]
                          ),
                      }"
                    >
                      <div class="input-wrapper">
                        <div class="label-row">
                          <label
                            class="floating-label"
                            for="transcript_issue_date_{{ i }}"
                            >Transcript Issued Date</label
                          >
                          @if (
                            isLowConfidence(
                              confidenceResult?.transcripts?.[i]?.college
                                ?.transcript_issue_date
                            ) && collegeEditIndex !== i
                          ) {
                            <app-low-confidence-tag
                              [confidenceScore]="
                                confidenceResult?.transcripts?.[i]?.college
                                  ?.transcript_issue_date
                              "
                              (markDataCorrect)="
                                markCollegeFieldAsCorrect(
                                  i,
                                  'transcript_issue_date'
                                )
                              "
                            ></app-low-confidence-tag>
                          }
                          @if (
                            savedChanges?.college?.[i]?.transcript_issue_date !=
                              undefined && collegeEditIndex !== i
                          ) {
                            <span class="edited-icon"
                              ><app-edited-field-tag
                                [previousValue]="
                                  savedChanges?.college?.[i]
                                    ?.transcript_issue_date
                                "
                              ></app-edited-field-tag>
                            </span>
                          }
                        </div>
                        <div class="">
                          <input
                            id="transcript_issue_date_{{ i }}"
                            type="text"
                            formControlName="transcript_issue_date"
                            [readonly]="collegeEditIndex !== i"
                            class="datepicker-input"
                            placeholder="-"
                            [ngClass]="{
                              'error-border':
                                collegeEditIndex === i &&
                                getCollegeForm(i)?.get('transcript_issue_date')
                                  ?.invalid &&
                                getCollegeForm(i)?.get('transcript_issue_date')
                                  ?.touched,
                            }"
                            title="{{
                              extractionResult?.transcripts?.[i]?.college
                                ?.transcript_issue_date
                            }}"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="field-container"
                      [class.edit-mode]="collegeEditIndex === i"
                      [ngClass]="{
                        'low-confidence': isLowConfidence(
                          confidenceResult?.transcripts?.[i]?.college
                            ?.college_accreditation?.is_accredited
                        ),
                        'edited-field':
                          savedChanges?.college?.[i]?.[
                            'college_accreditation'
                          ] != undefined &&
                          collegeEditIndex !== i &&
                          isLowConfidence(
                            savedConfidenceChanges?.college?.[i]?.[
                              'college_accreditation'
                            ]?.is_accredited
                          ),
                        'not-accredited':
                          !transcript?.college?.college_accreditation
                            ?.is_accredited,
                      }"
                    >
                      <div class="input-wrapper">
                        <div class="label-row">
                          <label
                            class="floating-label"
                            for="college_accreditation_{{ i }}"
                            >Accreditation</label
                          >
                          @if (
                            isLowConfidence(
                              confidenceResult?.transcripts?.[i]?.college
                                ?.college_accreditation?.is_accredited
                            ) && collegeEditIndex !== i
                          ) {
                            <app-low-confidence-tag
                              [confidenceScore]="
                                confidenceResult?.transcripts?.[i]?.college
                                  ?.college_accreditation?.is_accredited
                              "
                              (markDataCorrect)="
                                markCollegeFieldAsCorrect(
                                  i,
                                  'college_accreditation'
                                )
                              "
                            ></app-low-confidence-tag>
                          }
                          @if (
                            savedChanges?.college?.[i]?.[
                              "college_accreditation"
                            ] != undefined && collegeEditIndex !== i
                          ) {
                            <span class="edited-icon"
                              ><app-edited-field-tag
                                [previousValue]="
                                  savedChanges?.college?.[i]?.[
                                    'college_accreditation'
                                  ]
                                    ? 'Accredited'
                                    : 'Not Accredited'
                                "
                              ></app-edited-field-tag>
                            </span>
                          }
                        </div>
                        <select
                          id="college_accreditation_{{ i }}"
                          formControlName="is_accredited"
                          [class.readonly]="collegeEditIndex !== i"
                          [title]="
                            transcript?.college?.college_accreditation
                              ?.is_accredited
                              ? 'Accredited'
                              : 'Not Accredited'
                          "
                        >
                          <option [ngValue]="true">Accredited</option>
                          <option [ngValue]="false">Not Accredited</option>
                        </select>
                      </div>
                    </div>
                    @if (shouldRenderTranscriptVersionField()) {
                      <div
                        class="field-container"
                        [class.edit-mode]="collegeEditIndex === i"
                        [ngClass]="{
                          'low-confidence': isLowConfidence(
                            confidenceResult?.transcripts?.[i]?.college
                              ?.transcript_version
                          ),
                          'edited-field':
                            savedChanges?.college?.[i]?.[
                              'transcript_version'
                            ] &&
                            collegeEditIndex !== i &&
                            isLowConfidence(
                              savedConfidenceChanges?.college?.[i]?.[
                                'transcript_version'
                              ]
                            ),
                          duplicate:
                            getCollegeForm(i)?.get('transcript_version')
                              ?.value !== 'non_duplicate',
                        }"
                      >
                        <div class="input-wrapper">
                          <div class="label-row">
                            <label
                              class="floating-label"
                              for="college_transcript_version_{{ i }}"
                              >Transcript Version</label
                            >
                            @if (
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.college
                                  ?.transcript_version
                              ) && collegeEditIndex !== i
                            ) {
                              <app-low-confidence-tag
                                [confidenceScore]="
                                  confidenceResult?.transcripts?.[i]?.college
                                    ?.transcript_version
                                "
                                (markDataCorrect)="
                                  markCollegeFieldAsCorrect(
                                    i,
                                    'transcript_version'
                                  )
                                "
                              ></app-low-confidence-tag>
                            }
                            @if (
                              savedChanges?.college?.[i]?.[
                                "transcript_version"
                              ] != undefined && collegeEditIndex !== i
                            ) {
                              <span class="edited-icon"
                                ><app-edited-field-tag
                                  [previousValue]="
                                    savedChanges?.college?.[i]?.[
                                      'transcript_version'
                                    ] == 'duplicate'
                                      ? 'Duplicate'
                                      : 'Non-Duplicate'
                                  "
                                ></app-edited-field-tag>
                              </span>
                            }
                          </div>
                          <select
                            id="college_transcript_version_{{ i }}"
                            formControlName="transcript_version"
                            [class.readonly]="collegeEditIndex !== i"
                            [title]="
                              getCollegeForm(i)?.get('transcript_version')
                                ?.value
                            "
                          >
                            <option value="duplicate">Duplicate</option>
                            <option value="non_duplicate">Non-Duplicate</option>
                          </select>
                        </div>
                      </div>
                    }
                  </div>
                  @if (getTranscriptValidationMessage(i)) {
                    <div class="transcript-alert validation-alert">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip1_alert)">
                          <path
                            d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9Z"
                            stroke="#FA0000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 6.75V9.75"
                            stroke="#FA0000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 12V12.0075"
                            stroke="#FA0000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip1_alert">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span class="validation-message">
                        {{ getTranscriptValidationMessage(i) }}
                      </span>
                    </div>
                  }
                </div>
              }
              <div class="courses-section">
                <div class="course-header">
                  <div class="course-title">
                    <span class="info-header">Course Details</span>
                  </div>
                  @if (!isHighlightToggleChecked) {
                    <button
                      class="course-add-button"
                      (click)="addNewCourse()"
                      [attr.aria-expanded]="isCourseAddVisible"
                      [class.active]="
                        isCourseAddVisible || isEditActionLocked()
                      "
                      [disabled]="isCourseAddVisible || isEditActionLocked()"
                    >
                      Add New Course +
                    </button>
                  }
                </div>
                @if (isCourseAddVisible) {
                  <div class="course-add">
                    <div
                      class="course-information"
                      [class.edit-mode]="isCourseAddVisible"
                      [formGroup]="newCourseForm"
                    >
                      <div class="action-section horizontal-line">
                        <span class="info-header"
                          >Course
                          {{
                            extractionResult?.transcripts?.[
                              selectedTranscriptIndex
                            ]?.courses?.length + 1
                          }}
                        </span>
                        <span class="save-section">
                          <button
                            class="cancel-icon"
                            aria-label="Cancel course creation"
                            (click)="cancelCourseCreation()"
                          >
                            Cancel
                          </button>
                          <button
                            class="save-icon"
                            [class.disabled]="newCourseForm?.invalid"
                            (click)="saveCourseCreation(i)"
                          >
                            Save
                          </button>
                        </span>
                      </div>
                      <div class="form-section horizontal-line">
                        <!-- NEW COURSE CODE -->
                        <div class="field-container">
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="course_code_new"
                                >Course Code</label
                              >
                            </div>
                            <input
                              id="course_code_new"
                              type="text"
                              formControlName="course_code"
                              placeholder=" "
                              [ngClass]="{
                                'error-border':
                                  newCourseForm.get('course_code')?.invalid &&
                                  newCourseForm.get('course_code')?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- NEW COURSE NAME -->
                        <div class="field-container long-content">
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="course_name_new"
                                >Course Name</label
                              >
                            </div>
                            <input
                              type="text"
                              id="course_name_new"
                              formControlName="course_name"
                              placeholder=" "
                              [ngClass]="{
                                'error-border':
                                  newCourseForm.get('course_name')?.invalid &&
                                  newCourseForm.get('course_name')?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- NEW ATTENDANCE DATE (SEMESTER) -->
                        <div class="field-container">
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label class="floating-label" for="semester_new"
                                >Attendance Date</label
                              >
                            </div>
                            <input
                              id="semester_new"
                              type="text"
                              formControlName="semester"
                              placeholder=" "
                              [ngClass]="{
                                'error-border':
                                  newCourseForm.get('semester')?.invalid &&
                                  newCourseForm.get('semester')?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- NEW CREDITS ATTEMPTED -->
                        <div class="field-container">
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="credits_attempted_new"
                                >Credits Attempted</label
                              >
                            </div>
                            <input
                              id="credits_attempted_new"
                              type="number"
                              formControlName="credits_attempted"
                              min="0.00"
                              max="10.00"
                              step="0.5"
                              placeholder=" "
                              [ngClass]="{
                                'error-border':
                                  newCourseForm.get('credits_attempted')
                                    ?.invalid &&
                                  newCourseForm.get('credits_attempted')
                                    ?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- NEW CREDITS EARNED -->
                        <div class="field-container long-content">
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="credits_earned_new"
                                >Credits Earned</label
                              >
                            </div>
                            <input
                              id="credits_earned_new"
                              type="number"
                              formControlName="credits_earned"
                              min="0.00"
                              step="0.5"
                              placeholder=" "
                              title="Credits Earned cannot be greater than Credits Attempted"
                              [ngClass]="{
                                'error-border':
                                  (newCourseForm.get('credits_earned')
                                    ?.invalid &&
                                    newCourseForm.get('credits_earned')
                                      ?.touched) ||
                                  (newCourseForm.hasError('creditsMismatch') &&
                                    newCourseForm.get('credits_earned')
                                      ?.touched),
                              }"
                            />
                          </div>
                        </div>

                        <!-- NEW GRADE -->
                        <div class="field-container">
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label class="floating-label" for="grade_new"
                                >Grade</label
                              >
                            </div>
                            <input
                              type="text"
                              id="grade_new"
                              formControlName="grade"
                              maxlength="10"
                              placeholder=" "
                              [ngClass]="{
                                'error-border':
                                  newCourseForm.get('grade')?.invalid &&
                                  newCourseForm.get('grade')?.touched,
                              }"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @for (
                  course of transcript.courses;
                  track course;
                  let j = $index
                ) {
                  @if (
                    !isHighlightToggleChecked ||
                    (hasLowConfidenceInCourse(i, j) &&
                      course?.source !== "manual_entry")
                  ) {
                    <div
                      class="course-information"
                      [formGroup]="getCourseForm(i, j)"
                      [class.active-edit]="
                        activeEdit.section === 'course' &&
                        activeEdit.transcriptIndex === i &&
                        activeEdit.courseIndex === j
                      "
                    >
                      <div class="action-section horizontal-line">
                        <span class="info-header"
                          >Course {{ j + 1 }}
                          @if (course?.source === "manual_entry") {
                            <span class="new-course-tag">Added</span>
                          }
                        </span>
                        <span class="action-buttons">
                          @if (courseEditIndexMap[i] !== j) {
                            @if (course?.source === "manual_entry") {
                              <button
                                class="delete-icon"
                                [class.disabled]="isEditActionLocked()"
                                [style.pointer-events]="
                                  isEditActionLocked() ? 'none' : 'auto'
                                "
                                (click)="deleteCourse(i, j)"
                                [disabled]="isEditActionLocked()"
                                title="Delete"
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    clip-path="url(#clip0_del_{{ i }}_{{ j }})"
                                  >
                                    <path
                                      d="M9.75 8.25V6C9.75 5.80109 9.82902 5.61032 9.96967 5.46967C10.1103 5.32902 10.3011 5.25 10.5 5.25H13.5C13.6989 5.25 13.8897 5.32902 14.0303 5.46967C14.171 5.61032 14.25 5.80109 14.25 6V8.25"
                                      stroke="#5B5B5B"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M6 8.25H18"
                                      stroke="#5B5B5B"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M6.75 8.25L7.5 17.25C7.5 17.6478 7.65804 18.0294 7.93934 18.3107C8.22064 18.592 8.60218 18.75 9 18.75H15C15.3978 18.75 15.7794 18.592 16.0607 18.3107C16.342 18.0294 16.5 17.6478 16.5 17.25L17.25 8.25"
                                      stroke="#5B5B5B"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10 11V16"
                                      stroke="#5B5B5B"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M14 11V16"
                                      stroke="#5B5B5B"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_del_{{ i }}_{{ j }}">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </button>
                            }
                            <button
                              class="edit-icon"
                              (click)="editCourse(i, j)"
                              [class.disabled]="isEditActionLocked()"
                              [style.pointer-events]="
                                isEditActionLocked() ? 'none' : 'auto'
                              "
                              (keydown.enter)="editCourse(i, j)"
                              (keydown.space)="
                                $event.preventDefault(); editCourse(i, j)
                              "
                              [attr.tabindex]="isEditActionLocked() ? -1 : 0"
                              aria-label="Edit course"
                              title="Edit"
                            >
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_course_edit)">
                                  <path
                                    d="M3 15.0002H6L13.875 7.12523C14.072 6.92824 14.2282 6.69439 14.3348 6.43702C14.4415 6.17965 14.4963 5.9038 14.4963 5.62523C14.4963 5.34665 14.4415 5.0708 14.3348 4.81343C14.2282 4.55606 14.072 4.32221 13.875 4.12523C13.678 3.92824 13.4442 3.77199 13.1868 3.66538C12.9294 3.55878 12.6536 3.50391 12.375 3.50391C12.0964 3.50391 11.8206 3.55878 11.5632 3.66538C11.3058 3.77199 11.072 3.92824 10.875 4.12523L3 12.0002V15.0002Z"
                                    stroke="#5F626B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.125 4.875L13.125 7.875"
                                    stroke="#5F626B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_course_edit">
                                    <rect width="18" height="18" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                          }
                        </span>
                        @if (courseEditIndexMap[i] === j) {
                          <span class="save-section">
                            <button
                              class="cancel-icon"
                              (click)="cancelCourseEdit(i, j)"
                              (keydown.enter)="cancelCourseEdit(i, j)"
                              (keydown.space)="
                                $event.preventDefault(); cancelCourseEdit(i, j)
                              "
                              [attr.tabindex]="isEditActionLocked() ? -1 : 0"
                              aria-label="Cancel course edit"
                            >
                              Cancel
                            </button>
                            <span
                              class="save-icon"
                              (click)="saveCourseEdit(i, j)"
                              [class.disabled]="getCourseForm(i, j)?.invalid"
                              (keydown.enter)="saveCourseEdit(i, j)"
                              >Save</span
                            >
                          </span>
                        }
                      </div>
                      <div class="form-section horizontal-line">
                        <!-- COURSE CODE -->
                        <div
                          class="field-container"
                          [class.edit-mode]="courseEditIndexMap?.[i] === j"
                          [ngClass]="{
                            'low-confidence':
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.courses?.[j]
                                  ?.course_code
                              ) && course?.source !== 'manual_entry',
                            'edited-field':
                              savedChanges?.course?.[i]?.[j]?.course_code !=
                                undefined &&
                              courseEditIndexMap[i] !== j &&
                              isLowConfidence(
                                savedConfidenceChanges?.course?.[i]?.[j]
                                  ?.course_code
                              ) &&
                              course?.source !== 'manual_entry',
                          }"
                        >
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="course_code_{{ i }}_{{ j }}"
                                >Course Code</label
                              >
                              @if (course?.source !== "manual_entry") {
                                @if (
                                  isLowConfidence(
                                    confidenceResult?.transcripts?.[i]
                                      ?.courses?.[j]?.course_code
                                  ) && courseEditIndexMap[i] !== j
                                ) {
                                  <app-low-confidence-tag
                                    [confidenceScore]="
                                      confidenceResult?.transcripts?.[i]
                                        ?.courses?.[j]?.course_code
                                    "
                                    (markDataCorrect)="
                                      markCourseFieldAsCorrect(
                                        i,
                                        j,
                                        'course_code'
                                      )
                                    "
                                  ></app-low-confidence-tag>
                                }
                                @if (
                                  savedChanges?.course?.[i]?.[j]?.course_code !=
                                    undefined && courseEditIndexMap[i] !== j
                                ) {
                                  <span class="edited-icon"
                                    ><app-edited-field-tag
                                      [previousValue]="
                                        savedChanges?.course?.[i]?.[j]
                                          ?.course_code
                                      "
                                    ></app-edited-field-tag>
                                  </span>
                                }
                              }
                            </div>
                            <input
                              id="course_code_{{ i }}_{{ j }}"
                              type="text"
                              formControlName="course_code"
                              [readonly]="courseEditIndexMap[i] !== j"
                              [class.readonly]="courseEditIndexMap[i] !== j"
                              [ngClass]="{
                                'error-border':
                                  getCourseFormControl(i, j, 'course_code')
                                    ?.invalid &&
                                  getCourseFormControl(i, j, 'course_code')
                                    ?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- COURSE NAME -->
                        <div
                          class="field-container long-content"
                          [class.edit-mode]="courseEditIndexMap[i] === j"
                          [ngClass]="{
                            'low-confidence':
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.courses?.[j]
                                  ?.course_name
                              ) && course?.source !== 'manual_entry',
                            'edited-field':
                              savedChanges?.course?.[i]?.[j]?.course_name !=
                                undefined &&
                              courseEditIndexMap[i] !== j &&
                              isLowConfidence(
                                savedConfidenceChanges?.course?.[i]?.[j]
                                  ?.course_name
                              ) &&
                              course?.source !== 'manual_entry',
                          }"
                        >
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="course_name_{{ i }}_{{ j }}"
                                >Course Name</label
                              >
                              @if (course?.source !== "manual_entry") {
                                @if (
                                  isLowConfidence(
                                    confidenceResult?.transcripts?.[i]
                                      ?.courses?.[j]?.course_name
                                  ) && courseEditIndexMap[i] !== j
                                ) {
                                  <app-low-confidence-tag
                                    [confidenceScore]="
                                      confidenceResult?.transcripts?.[i]
                                        ?.courses?.[j]?.course_name
                                    "
                                    (markDataCorrect)="
                                      markCourseFieldAsCorrect(
                                        i,
                                        j,
                                        'course_name'
                                      )
                                    "
                                  ></app-low-confidence-tag>
                                }
                                @if (
                                  savedChanges?.course?.[i]?.[j]?.course_name !=
                                    undefined && courseEditIndexMap[i] !== j
                                ) {
                                  <span class="edited-icon"
                                    ><app-edited-field-tag
                                      [previousValue]="
                                        savedChanges?.course?.[i]?.[j]
                                          ?.course_name
                                      "
                                    ></app-edited-field-tag>
                                  </span>
                                }
                              }
                            </div>
                            <input
                              type="text"
                              id="course_name_{{ i }}_{{ j }}"
                              formControlName="course_name"
                              [readonly]="courseEditIndexMap[i] !== j"
                              [class.readonly]="courseEditIndexMap[i] !== j"
                              [title]="course.course_name"
                              [ngClass]="{
                                'error-border':
                                  getCourseFormControl(i, j, 'course_name')
                                    ?.invalid &&
                                  getCourseFormControl(i, j, 'course_name')
                                    ?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- ATTENDANCE DATE (SEMESTER) -->
                        <div
                          class="field-container"
                          [class.edit-mode]="courseEditIndexMap[i] === j"
                          [ngClass]="{
                            'low-confidence':
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.courses?.[j]
                                  ?.semester
                              ) && course?.source !== 'manual_entry',
                            'edited-field':
                              savedChanges?.course?.[i]?.[j]?.semester !=
                                undefined &&
                              courseEditIndexMap[i] !== j &&
                              isLowConfidence(
                                savedConfidenceChanges?.course?.[i]?.[j]
                                  ?.semester
                              ) &&
                              course?.source !== 'manual_entry',
                          }"
                        >
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="semester_{{ i }}_{{ j }}"
                                >Attendance Date</label
                              >
                              @if (course?.source !== "manual_entry") {
                                @if (
                                  isLowConfidence(
                                    confidenceResult?.transcripts?.[i]
                                      ?.courses?.[j]?.semester
                                  ) && courseEditIndexMap[i] !== j
                                ) {
                                  <app-low-confidence-tag
                                    [confidenceScore]="
                                      confidenceResult?.transcripts?.[i]
                                        ?.courses?.[j]?.semester
                                    "
                                    (markDataCorrect)="
                                      markCourseFieldAsCorrect(i, j, 'semester')
                                    "
                                  ></app-low-confidence-tag>
                                }
                                @if (
                                  savedChanges?.course?.[i]?.[j]?.semester !=
                                    undefined && courseEditIndexMap[i] !== j
                                ) {
                                  <span class="edited-icon"
                                    ><app-edited-field-tag
                                      [previousValue]="
                                        savedChanges?.course?.[i]?.[j]?.semester
                                      "
                                    ></app-edited-field-tag>
                                  </span>
                                }
                              }
                            </div>
                            <input
                              id="semester_{{ i }}_{{ j }}"
                              type="text"
                              formControlName="semester"
                              [readonly]="courseEditIndexMap[i] !== j"
                              [class.readonly]="courseEditIndexMap[i] !== j"
                              [ngClass]="{
                                'error-border':
                                  getCourseFormControl(i, j, 'semester')
                                    ?.invalid &&
                                  getCourseFormControl(i, j, 'semester')
                                    ?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- CREDITS ATTEMPTED -->
                        <div
                          class="field-container"
                          [class.edit-mode]="courseEditIndexMap[i] === j"
                          [ngClass]="{
                            'low-confidence':
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.courses?.[j]
                                  ?.credits_attempted
                              ) && course?.source !== 'manual_entry',
                            'edited-field':
                              savedChanges?.course?.[i]?.[j]
                                ?.credits_attempted != undefined &&
                              courseEditIndexMap[i] !== j &&
                              isLowConfidence(
                                savedConfidenceChanges?.course?.[i]?.[j]
                                  ?.credits_attempted
                              ) &&
                              course?.source !== 'manual_entry',
                          }"
                        >
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="credits_attempted_{{ i }}_{{ j }}"
                                >Credits Attempted</label
                              >
                              @if (course?.source !== "manual_entry") {
                                @if (
                                  isLowConfidence(
                                    confidenceResult?.transcripts?.[i]
                                      ?.courses?.[j]?.credits_attempted
                                  ) && courseEditIndexMap[i] !== j
                                ) {
                                  <app-low-confidence-tag
                                    [confidenceScore]="
                                      confidenceResult?.transcripts?.[i]
                                        ?.courses?.[j]?.credits_attempted
                                    "
                                    (markDataCorrect)="
                                      markCourseFieldAsCorrect(
                                        i,
                                        j,
                                        'credits_attempted'
                                      )
                                    "
                                  ></app-low-confidence-tag>
                                }
                                @if (
                                  savedChanges?.course?.[i]?.[j]
                                    ?.credits_attempted != undefined &&
                                  courseEditIndexMap[i] !== j
                                ) {
                                  <span class="edited-icon"
                                    ><app-edited-field-tag
                                      [previousValue]="
                                        savedChanges?.course?.[i]?.[j]
                                          ?.credits_attempted
                                      "
                                    ></app-edited-field-tag>
                                  </span>
                                }
                              }
                            </div>
                            <input
                              id="credits_attempted_{{ i }}_{{ j }}"
                              type="number"
                              formControlName="credits_attempted"
                              [readonly]="courseEditIndexMap[i] !== j"
                              [class.readonly]="courseEditIndexMap[i] !== j"
                              min="0.00"
                              max="10.00"
                              step="0.5"
                              [ngClass]="{
                                'error-border':
                                  getCourseFormControl(
                                    i,
                                    j,
                                    'credits_attempted'
                                  )?.invalid &&
                                  getCourseFormControl(
                                    i,
                                    j,
                                    'credits_attempted'
                                  )?.touched,
                              }"
                            />
                          </div>
                        </div>

                        <!-- CREDITS EARNED -->
                        <div
                          class="field-container long-content"
                          [class.edit-mode]="courseEditIndexMap[i] === j"
                          [ngClass]="{
                            'low-confidence':
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.courses?.[j]
                                  ?.credits_earned
                              ) && course?.source !== 'manual_entry',
                            'edited-field':
                              savedChanges?.course?.[i]?.[j]?.credits_earned !=
                                undefined &&
                              courseEditIndexMap[i] !== j &&
                              isLowConfidence(
                                savedConfidenceChanges?.course?.[i]?.[j]
                                  ?.credits_earned
                              ) &&
                              course?.source !== 'manual_entry',
                          }"
                        >
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="credits_earned_{{ i }}_{{ j }}"
                                >Credits Earned</label
                              >
                              @if (course?.source !== "manual_entry") {
                                @if (
                                  isLowConfidence(
                                    confidenceResult?.transcripts?.[i]
                                      ?.courses?.[j]?.credits_earned
                                  ) && courseEditIndexMap[i] !== j
                                ) {
                                  <app-low-confidence-tag
                                    [confidenceScore]="
                                      confidenceResult?.transcripts?.[i]
                                        ?.courses?.[j]?.credits_earned
                                    "
                                    (markDataCorrect)="
                                      markCourseFieldAsCorrect(
                                        i,
                                        j,
                                        'credits_earned'
                                      )
                                    "
                                  ></app-low-confidence-tag>
                                }
                                @if (
                                  savedChanges?.course?.[i]?.[j]
                                    ?.credits_earned != undefined &&
                                  courseEditIndexMap[i] !== j
                                ) {
                                  <span class="edited-icon"
                                    ><app-edited-field-tag
                                      [previousValue]="
                                        savedChanges?.course?.[i]?.[j]
                                          ?.credits_earned
                                      "
                                    ></app-edited-field-tag>
                                  </span>
                                }
                              }
                            </div>
                            <input
                              id="credits_earned_{{ i }}_{{ j }}"
                              type="number"
                              formControlName="credits_earned"
                              [readonly]="courseEditIndexMap[i] !== j"
                              [class.readonly]="courseEditIndexMap[i] !== j"
                              min="0.00"
                              step="0.5"
                              [ngClass]="{
                                'error-border':
                                  (getCourseFormControl(i, j, 'credits_earned')
                                    ?.invalid &&
                                    getCourseFormControl(i, j, 'credits_earned')
                                      ?.touched) ||
                                  (getCourseForm(i, j)?.hasError(
                                    'creditsMismatch'
                                  ) &&
                                    getCourseFormControl(i, j, 'credits_earned')
                                      ?.touched),
                              }"
                              title="Credits Earned cannot be greater than Credits Attempted"
                            />
                          </div>
                        </div>

                        <!-- GRADE -->
                        <div
                          class="field-container"
                          [class.edit-mode]="courseEditIndexMap[i] === j"
                          [ngClass]="{
                            'low-confidence':
                              isLowConfidence(
                                confidenceResult?.transcripts?.[i]?.courses?.[j]
                                  ?.grade
                              ) && course?.source !== 'manual_entry',
                            'edited-field':
                              savedChanges?.course?.[i]?.[j]?.grade !=
                                undefined &&
                              courseEditIndexMap[i] !== j &&
                              isLowConfidence(
                                savedConfidenceChanges?.course?.[i]?.[j]?.grade
                              ) &&
                              course?.source !== 'manual_entry',
                          }"
                        >
                          <div class="input-wrapper">
                            <div class="label-row">
                              <label
                                class="floating-label"
                                for="grade_{{ i }}_{{ j }}"
                                >Grade</label
                              >
                              @if (course?.source !== "manual_entry") {
                                @if (
                                  isLowConfidence(
                                    confidenceResult?.transcripts?.[i]
                                      ?.courses?.[j]?.grade
                                  ) && courseEditIndexMap[i] !== j
                                ) {
                                  <app-low-confidence-tag
                                    [confidenceScore]="
                                      confidenceResult?.transcripts?.[i]
                                        ?.courses?.[j]?.grade
                                    "
                                    (markDataCorrect)="
                                      markCourseFieldAsCorrect(i, j, 'grade')
                                    "
                                  ></app-low-confidence-tag>
                                }
                                @if (
                                  savedChanges?.course?.[i]?.[j]?.grade !=
                                    undefined && courseEditIndexMap[i] !== j
                                ) {
                                  <span class="edited-icon"
                                    ><app-edited-field-tag
                                      [previousValue]="
                                        savedChanges?.course?.[i]?.[j]?.grade
                                      "
                                    ></app-edited-field-tag>
                                  </span>
                                }
                              }
                            </div>
                            <input
                              type="text"
                              id="grade_{{ i }}_{{ j }}"
                              formControlName="grade"
                              [readonly]="courseEditIndexMap[i] !== j"
                              [class.readonly]="courseEditIndexMap[i] !== j"
                              maxlength="10"
                              [ngClass]="{
                                'error-border':
                                  getCourseFormControl(i, j, 'grade')
                                    ?.invalid &&
                                  getCourseFormControl(i, j, 'grade')?.touched,
                              }"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </mat-tab>
          }
        }
      </mat-tab-group>
    </div>
  </div>
  <div class="extraction-feedback">
    <app-mmp-feedback [feedBackStage]="currentStage"></app-mmp-feedback>
  </div>
  <div class="extraction-footer">
    @if (extractionResult) {
      <button
        class="mmp-btn-primary"
        [class.disabled]="
          !isAnyCollegeAccredited() ||
          isEditLocked() ||
          areAllCreditSystemsEmpty() ||
          !isAnyCollegeHasName() ||
          isExtractionInProgress() ||
          hasDuplicateOrOlderTranscriptVersion()
        "
        [matTooltip]="getSaveProceedTooltip()"
        (click)="handleSaveAndProceedClick($event)"
      >
        Save & Proceed to Evaluation
      </button>
    }
  </div>
</div>
